import style from "./CustomBtn.module.css";
import Typography from "@mui/material/Typography";

function CustomBtn(props) {
  var className = style.CustomBtn + " ";
  if (props.className) {
    className += props.className;
  }
  return (
    <button
      className={className}
      style={{
        background: props.bgcolor,
        border: "1.19851px solid " + props.borderColor,
      }}
      {...props}
    >
      <Typography
        variant={props.variant}
        style={{ color: props.fontcolor }}
        className={style.CustomBtnTxt}
      >
        {props.children}
      </Typography>
    </button>
  );
}

export default CustomBtn;
